<script setup lang="ts">
import { StallColors, type StallData } from '~/lib/stall';

interface Props {
  data: StallData
  index: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click', value: MouseEvent): void
}>()

const images = import.meta.glob("~/public/img/stall/**/*",  { eager: true, import: "default" })

function getImagePath(images: Record<string, unknown>) {
  const org = props.data['画像ID'].split('_')[0]
  const image = Object.entries(images).find(([path, _]) => {
    const mather = `/public/img/stall/${org}/${props.data['画像ID']}.jpg`
    return path.includes(mather)
  }) as [string, string]
  
  if (image) {
    return image[0].replace(/^\/public/, '')
  } else {
    console.warn(`Image not found for booth: 【${props.data['ID']}】 ${props.data['団体名']} ${props.data['企画名']} `)
    return "/favicon.jpg"
  }
}
</script>

<template>
  <div :id="String(index + 1)"
    class="pb-2 w-full shadow hover:opacity-80 transition-opacity cursor-pointer shadow-gray-400 rounded overflow-hidden max-w-[400px]"
    @click="emit('click', $event)">
    <div class="h-1.5 mb-3" />
    <div class="mr-1 p-0 grid grid-cols-[auto_1fr] gap-x-2 gap-y-0">
      <div class="row-span-2 grid place-items-center">
        <div class="w-[100px] h-[60px] grid place-items-center text-white rounded-r"
          :style="{ 'background-color': StallColors[props.data['エリアID']] }">
          <span v-if="!props.data['場所']" class="text-4xl">
            {{ props.data["エリアID"] }} - {{ props.data["No."] }}
          </span>
          <span v-if="props.data['場所']" class="text-2xl">
            {{ props.data["エリアID"] }} - {{ props.data["No."] }}
          </span>
          <span v-if="props.data['場所']" class="text-sm">
            （{{ props.data["場所"] }}）
          </span>
        </div>
      </div>
      <h3 class="text-md flex flex-wrap justify-center gap-x-2 text-center">
        <span v-for="text in props.data['団体名'].split(';')">
          {{ text }}
        </span>
      </h3>
      <h2 class="text-2xl flex flex-wrap justify-center gap-x-2 text-center">
        <span v-for="text in props.data['企画名'].split(';')">
          {{ text }}
        </span>
      </h2>
    </div>
    <div class="col-span-3 divider my-0" />
    <div class="grid grid-cols-[1fr_minmax(0,min(35%,124px))] my-1 gap-2">
      <div class="mx-1 p-0 grid grid-cols-[auto_1fr] gap-y-4 gap-x-0 h-fit">
        <div class="mx-1 p-0 text-center text-lg">
          <span v-for="text in props.data['概要'].split(';')">
            {{ text }}
          </span>
        </div>
      </div>
      <div class="grid justify-end items-center">
        <NuxtImg class="max-h-[124px]" format="webp" :src="getImagePath(images)" decoding="async" loading="lazy" />
      </div>
    </div>
  </div>
</template>
